"use strict";
/*!
 *
 *  senior.ts
 *
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Nav = exports.Details = exports.Sort = void 0;
var vue_1 = __importDefault(require("vue"));
var axios_1 = __importDefault(require("axios"));
var shuffle_1 = __importDefault(require("shuffle"));
var Sort = /** @class */ (function () {
    function Sort() {
        this.sort = '#SeniorSort';
        this.json = '/jinji/job/senior/data/senior.json';
        this.gutter = util.viewport !== 'phone' ? 24 : 12;
        if ($(this.sort).length) {
            this.getData();
        }
        ;
    }
    ;
    Sort.prototype.getData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, axios_1.default.get(this.json)];
                    case 1:
                        res = _a.sent();
                        this.data = (0, shuffle_1.default)(res.data);
                        this.init();
                        return [2 /*return*/];
                }
            });
        });
    };
    Sort.prototype.init = function () {
        var self = this;
        this.app = new vue_1.default({
            el: self.sort,
            data: {
                year: 0,
                affili: 0,
                kind: 0,
                list: self.data,
                inited: false,
                resultHeight: ($(self.sort).width() + self.gutter) * 0.25 - self.gutter
            },
            computed: {
                activeList: function () {
                    var _this = this;
                    return this.list.filter(function (val) {
                        var year = _this.year === 0 || val.year === Number(_this.year);
                        var affili = _this.affili === 0 || val.affili === Number(_this.affili);
                        var kind = _this.kind === 0 || val.kind === Number(_this.kind);
                        return year && affili && kind;
                    });
                }
            },
            mounted: function () {
                var _this = this;
                this.inited = true;
                $(window).on('resize', function () {
                    var gutter = util.viewport !== 'phone' ? 24 : 12;
                    _this.resultHeight = ($(self.sort).width() + gutter) * 0.25 - gutter;
                });
            },
            methods: {
                reset: function () {
                    this.year = 0;
                    this.affili = 0;
                    this.kind = 0;
                }
            }
        });
    };
    return Sort;
}());
exports.Sort = Sort;
var Details = /** @class */ (function () {
    function Details() {
        var _this = this;
        this.$elem = $('.snr-Career');
        this.$details = this.$elem.children('.snr-Career_Details');
        this.$btn = this.$elem.children('.snr-Career_Btn');
        if (this.$elem.length) {
            if (this.$details.length) {
                this.$btn.on('click', function (e) {
                    e.preventDefault();
                    _this.toggle();
                });
            }
            else {
                if (this.$btn.length) {
                    this.$btn.hide(0);
                }
                ;
            }
            ;
        }
        ;
    }
    Details.prototype.toggle = function () {
        this.$details.stop(false, true).slideToggle(700, 'easeOutExpo');
        var text = this.$btn.text() === 'Close' ? 'Open' : 'Close';
        this.$btn.html(text).toggleClass('-open');
        var top = this.$elem.closest('.c-Box').offset().top;
        $(util.scroller).animate({
            scrollTop: top - util.scrollGap
        }, {
            duration: 700,
            easing: 'easeOutExpo',
            queue: false
        });
    };
    return Details;
}());
exports.Details = Details;
var Nav = /** @class */ (function () {
    function Nav() {
        this.nav = '#SeniorNavList';
        this.json = '/jinji/job/senior/data/senior.json';
        if ($(this.nav).length) {
            this.getData();
        }
        ;
    }
    ;
    Nav.prototype.getData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, axios_1.default.get(this.json)];
                    case 1:
                        res = _a.sent();
                        this.data = (0, shuffle_1.default)(res.data);
                        this.init();
                        return [2 /*return*/];
                }
            });
        });
    };
    Nav.prototype.init = function () {
        var self = this;
        this.app = new vue_1.default({
            el: self.nav,
            data: {
                year: 0,
                affili: 0,
                kind: 0,
                list: self.data,
                inited: false,
                exclus: $(self.nav).data('exclus')
            },
            computed: {
                activeList: function () {
                    var _this = this;
                    return self.random(this.list.filter(function (val) {
                        return val.id !== _this.exclus;
                    }), 4);
                }
            },
            mounted: function () {
                this.inited = true;
            },
            methods: {
                reset: function () {
                    this.year = 0;
                    this.affili = 0;
                    this.kind = 0;
                }
            }
        });
    };
    Nav.prototype.random = function (arr, num) {
        var a = arr;
        var t = [];
        var r = [];
        var l = a.length;
        var n = num < l ? num : l;
        while (n-- > 0) {
            var i = Math.random() * l | 0;
            r[n] = t[i] || a[i];
            --l;
            t[i] = t[l] || a[l];
        }
        return r;
    };
    return Nav;
}());
exports.Nav = Nav;
